import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'

import Typography from 'material-ui/Typography'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'

import styles from 'styles/components/CardTitle'

@withStyles(styles)
@observer
export default class CardTitle extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired
  }

  render() {
    const { classes, title } = this.props

    return (
      <AppBar elevation={0} position="static" color="default">
        <Toolbar className={ classes.toolbar }>
          <Typography type='body2' > { title } </Typography>
        </Toolbar>
      </AppBar>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/CardTitle.js